/*
 * Vey's redesign — /collections index.
 * Client-side filtering for the category directory: hides rows, empty
 * letter groups and unused jump-bar letters as you type, and keeps the
 * category counter in sync. Progressive enhancement — without JS the
 * full index still renders and every link works.
 */
(function () {
  var normalise = function (value) {
    return (value || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/\s+/g, ' ')
      .trim();
  };

  /* The theme header is sticky (store-header[data-is-sticky]); park the
     filter bar right under it instead of at the viewport top. */
  var syncHeaderOffset = function (root) {
    /* .cc-header is the header section wrapper; main.js turns it into the
       sticky element (.cc-header--sticky) a tick after load. */
    var section = document.querySelector('.cc-header');
    var sticky = section && getComputedStyle(section).position === 'sticky';
    root.style.setProperty('--veys-idx-offset', sticky ? section.offsetHeight + 'px' : '0px');
  };

  var init = function (root) {
    var input = root.querySelector('[data-veys-index-filter]');
    var totalEl = root.querySelector('[data-veys-index-total]');
    var groups = Array.prototype.slice.call(root.querySelectorAll('[data-veys-index-group]'));
    var letters = Array.prototype.slice.call(root.querySelectorAll('[data-veys-index-letter]'));
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    syncHeaderOffset(root);
    /* The sticky class lands after a setTimeout in main.js — re-measure once. */
    window.setTimeout(function () { syncHeaderOffset(root); }, 300);
    window.addEventListener('load', function () { syncHeaderOffset(root); });
    window.addEventListener('resize', function () { syncHeaderOffset(root); });
    window.addEventListener('on:debounced-resize', function () { syncHeaderOffset(root); });

    var entries = groups.map(function (group) {
      return {
        el: group,
        letter: group.getAttribute('data-veys-index-group'),
        rows: Array.prototype.slice.call(group.querySelectorAll('.veys-idx__row')).map(function (row) {
          var name = row.querySelector('.veys-idx__name');
          return { el: row, term: normalise(name ? name.textContent : '') };
        })
      };
    });

    /* Smooth jump that respects the sticky filter bar (scroll-margin-top). */
    letters.forEach(function (link) {
      link.addEventListener('click', function (event) {
        var target = document.getElementById(decodeURIComponent((link.getAttribute('href') || '').slice(1)));
        if (!target) return;
        event.preventDefault();
        target.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
      });
    });

    if (!input) return;

    var apply = function () {
      var query = normalise(input.value);
      var visible = 0;
      var active = {};

      entries.forEach(function (entry) {
        var shown = 0;

        entry.rows.forEach(function (row) {
          var match = query === '' || row.term.indexOf(query) !== -1;
          row.el.hidden = !match;
          if (match) shown++;
        });

        entry.el.hidden = shown === 0;
        visible += shown;
        if (shown > 0) active[entry.letter] = true;
      });

      letters.forEach(function (link) {
        link.classList.toggle('is-disabled', !active[link.getAttribute('data-veys-index-letter')]);
      });

      if (totalEl) totalEl.textContent = visible;
      root.classList.toggle('is-empty', visible === 0);
    };

    input.addEventListener('input', apply);
    input.addEventListener('search', apply);

    /* Escape clears the field. */
    input.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && input.value !== '') {
        event.preventDefault();
        input.value = '';
        apply();
      }
    });

    /* Browsers restore the field's value on back-navigation. */
    if (input.value !== '') apply();
  };

  var start = function () {
    Array.prototype.forEach.call(document.querySelectorAll('[data-veys-index]'), init);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
